import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/content';
const FIRST_DELAY = 6000;
const VISIBLE_MS = 5200;
const GAP_MS = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [shown, setShown] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const timeouts = useRef<number[]>([]);
  useEffect(() => {
    if (dismissed) return;
    const cycle = (delay: number) => {
      const t1 = window.setTimeout(() => {
        setShown(true);
        const t2 = window.setTimeout(() => {
          setShown(false);
          setIndex(prev => (prev + 1) % purchaseNotifications.length);
          cycle(GAP_MS);
        }, VISIBLE_MS);
        timeouts.current.push(t2);
      }, delay);
      timeouts.current.push(t1);
    };
    cycle(FIRST_DELAY);
    return () => {
      timeouts.current.forEach(t => window.clearTimeout(t));
      timeouts.current = [];
    };
  }, [dismissed]);
  const item = purchaseNotifications[index];
  const minutes = 2 + index * 3 % 11;
  return <div className="pointer-events-none fixed inset-x-0 top-0 z-50 flex justify-center px-3 pt-3 sm:justify-start sm:px-4 sm:pt-4" data-id="element-39" data-mp="1151uts5lgfj9">
      <AnimatePresence data-id="element-40" data-mp="1awfqtpyc6x7n">
        {shown && !dismissed ? <motion.div key={index} initial={{
        opacity: 0,
        y: -14,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -14,
        scale: 0.97
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} role="status" className="pointer-events-auto flex w-full max-w-[360px] items-start gap-3 rounded-2xl bg-white p-3 shadow-[0_14px_36px_-14px_rgba(10,10,12,0.45)] ring-1 ring-ink/10" data-id="element-41" data-mp="1az1yrqp53eqe">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-blood/10" data-id="element-42" data-mp="28mas27vdts2y">
              <CheckCircle2Icon className="h-5 w-5 text-blood" aria-hidden="true" data-id="element-43" data-mp="2aol3ubat2827" />
            </span>
            <div className="min-w-0 flex-1" data-id="element-44" data-mp="2fmd0fimeaicq">
              <p className="text-[13px] font-bold leading-snug text-ink" data-id="element-45" data-mp="2kmr64u0ixg7l">
                {item.name}
              </p>
              <p className="text-[12px] leading-snug text-graphite/75" data-id="element-46" data-mp="2pmdjr4k9kygx">
                just purchased{' '}
                <span className="font-semibold text-ink" data-id="element-47" data-mp="1ryv377kd2s2d">
                  Hypertension Route
                </span>
              </p>
              <p className="mt-1 text-[11px] font-medium text-graphite/55" data-id="element-48" data-mp="1wxg315vpb9qa">
                {item.place} · {minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="-mr-1 -mt-1 rounded-full p-1.5 text-graphite/40 transition-colors duration-150 ease-out hover:bg-cream hover:text-ink" data-id="element-49" data-mp="26n7z64jg8awv">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-50" data-mp="3rh8453jvafjq" />
            </button>
          </motion.div> : null}
      </AnimatePresence>
    </div>;
}